import { render, staticRenderFns } from "./design-data-export-modal.vue?vue&type=template&id=476fc817"
import script from "./design-data-export-modal.vue?vue&type=script&lang=js"
export * from "./design-data-export-modal.vue?vue&type=script&lang=js"
import style0 from "./design-data-export-modal.vue?vue&type=style&index=0&id=476fc817&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports